import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { styled } from 'styled-components';
import { Container } from '@design-system/container';
import { Content } from './Content';
import { Picture } from './Picture';
export const ContentWithPicture = ({ coverPictureUrls, description, filteredControls, isPreview, showContent, showControls, showDescription, showPicture, title, }) => {
    const contentHeight = {
        l: 252,
        m: 282,
        s: 'auto',
        xl: 310,
    };
    const widthContent = {
        l: 454,
        m: 414,
        s: '100%',
        xl: isPreview ? 'unset' : 678,
    };
    return (_jsxs(StyledContainer, { dataTestId: "appheader-container", flexDirection: { _: 'column', m: 'row' }, children: [_jsx(Content, { contentHeight: contentHeight, description: description, filteredControls: filteredControls, showControls: showControls, showDescription: showDescription, showPicture: showPicture, title: title, widthContent: widthContent }), _jsx(Picture, { coverPictureUrls: coverPictureUrls, showContent: showContent })] }));
};
const StyledContainer = styled(Container).attrs(() => ({
    justifyContent: 'center',
    px: {
        m: 6,
        xl: 8,
    },
    py: {
        m: 4,
        xl: 6,
    },
})) ``;
//# sourceMappingURL=ContentWithPicture.js.map